import React, { Fragment, useEffect, useRef, useState } from "react";
import './main.css'
import mainBanner from "assets/images/customer_main_banner.jpg"
import bottomBanner from "assets/images/customer_bottom_banner.jpg"
import storeSvg13 from "assets/images/svg/store_svg13.svg"
import storeSvg14 from "assets/images/svg/store_svg14.svg"
import leftArrow from "assets/images/svg/pagination_left_arrow.svg"
import leftArrowDisabled from "assets/images/svg/pagination_left_arrow_disabled.svg"
import rightArrow from "assets/images/svg/pagination_right_arrow.svg"
import rightArrowDisabled from "assets/images/svg/pagination_right_arrow_disabled.svg"
import omission from "assets/images/svg/omission.svg"
import download from "assets/images/svg/company_profile_download.svg"
import { saveContactData } from "crud/contact.crud";
import { getNewsByPage } from 'crud/auth.crud';
import SweetAlert from "react-bootstrap-sweetalert"
import moment from 'moment';
import Util from "pages/Dashboard/Common/Util";
import news1 from "assets/images/news1.jpg"
import news2 from "assets/images/news2.jpg"
import news3 from "assets/images/news3.png"
import news4 from "assets/images/news4.png"
import news5 from "assets/images/news5.png"

const weaverNews = [
  {
    title: "IOT기술 기반 음식물쓰레기 스마트 수거 혁신 플랫폼 '웨이스트버스'",
    date: '2025-09-08',
    content: "[e-뉴스 25=백지나 기자] (주)웨이스트버스는 세계 최초로 IoT 기술을 적용한 음식물 쓰레기 수거 플랫폼인 '웨이스트버스'를 정식 출시 예정이라고 밝혔다.\n웨이스트버스는 음식물 쓰레기의 배출량을 정확하게 측정하고 이를 바탕으로 수거, 운반, 처리의 모든 과정을 디지털화해 제공하는 혁신적인 서비스로, 음식물 쓰레기 관리의 투명성과 효율성을 극대화할 것으로 기대된다.",
    img: news1,
    url: 'https://www.e-news25.co.kr/m/view.php?idx=8026'
  },
  {
    title: "웨이스트버스-한국탄소중립협회, 탄소중립 및 디지털 환경혁신 위한 업무협약(MOU) 체결",
    date: '2025-08-29',
    content: "㈜웨이스트버스(대표 김호중)는 2025년 9월 1일 한국탄소중립협회(회장 박은남)와 함께 민간 주도의 ‘2050 탄소중립’ 실현과 디지털 기반 기후대응 혁신을 목표로 하는 전략적 업무협약(MOU)을 공식 체결했다고 밝혔다.",
    img: news2,
    url: 'https://www.startupdaily.kr/news/articleView.html?idxno=7834'
  },
  {
    title: '웨이스트버스, AIoT 기반 음식물 쓰레기 수거ㆍ유통 혁신, "웨이스트버스" 플랫폼 출시 예정!',
    date: '2025-10-15',
    content: '웨이스트버스는 세계 최초로 AIoT 기술을 적용한 음식물 쓰레기 수거 플랫폼인 "웨이스트버스"를 2025년 상반기에 정식 출시 예정이라고 밝혔다. 웨이스트버스는 음식물 쓰레기의 배출량을 정확하게 측정하고 이를 바탕으로 수거ㆍ 운반ㆍ처리의 모든 과정을 디지털화해 제공하는 혁신적인 서비스로, 음식물 쓰레기 관리의 투명성과 효율성을 극대화할 것으로 기대된다.',
    img: news3,
    url: 'https://www.mediapia.co.kr/news/articleView.html?idxno=70212'
  },
  {
    title: "라이셀-웨이스트버스, 탄소중립 및 음식물 쓰레기 자원순환 혁신을 위한 MOU 체결!",
    date: '2025-09-01',
    content: "건물 CO₂ 포집·자원화 선도기업 라이셀과 AIoT 기반 음식물쓰레기 수거 플랫폼 웨이스트버스가 ‘지속가능한 탄소중립 및 음식물 쓰레기 자원화’ 사업 협력을 위한 업무협약(MOU)을 체결했다.",
    img: news4,
    url: 'https://www.mediapia.co.kr/news/articleView.html?idxno=74958'
  },
  {
    title: "[기업소식] 웨이스트버스, 한국탄소중립협회 및 라이셀과 민간중심 탄소중립 실천을 위한 전략적 MOU 체결",
    date: '2025-09-02',
    content: "2025년 9월 1일(월) – IoT 기반 음식물 쓰레기 스마트 수거 혁신플랫폼인 ㈜웨이스트버스(대표 김호중)는 한국탄소중립협회(회장 박은남)와 민간 주도 2050 탄소중립 실현과 디지털 기후대응 혁신을 위한 전략적 업무협약(MOU)을 체결했다고 밝혔다. 이번 협약식에는 한국탄소중립협회 박은남 회장(라이셀 대표), 임만택 상임부회장, 김승섭 이사와 최재우 사무총장이 참석했고, 주식회사 웨이스트버스에서는 김호중 대표(미래이엔디 대표), 이병교 CTO(엠알오커머스 대표)가 참석했다.",
    img: news5,
    url: 'https://koreaartnews.com/post/YZ6wuYxW'
  },
]

const CustomerSupport = () => {
  const [subject, setSubject] = useState('')
  const [localPart, setLocalPart] = useState('') // 이메일 앞부분
  const [domain, setDomain] = useState('') // 이메일 뒷부분
  const [content, setContent] = useState('')
  const [modalShow, setModalShow] = useState({
    contact : false,
    service : false
  });    
  const [alertTitle, setAlertTitle] = useState({
    contact : '',
    service : ''
  });
  const [isAgree, setIsAgree] = useState(false)
  const [newsList, setNewsList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState('');
  const [pageList, setPageList] = useState([])

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key] : true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key] : false}))
  }

  const writeAlertTitle = (key, title) => {
    setAlertTitle(prev => ({...prev, [key] : title}))
  }

  const isContactValid = () => {
    if(!subject){
      writeAlertTitle('contact', '문의제목을 입력해 주세요')
      modalOpen('contact')
      return false
    }else if(!(localPart && domain)){
      writeAlertTitle('contact', '이메일을 입력해 주세요')
      modalOpen('contact')
      return false
    }else if(!content){
      writeAlertTitle('contact', '문의내용을 입력해 주세요')
      modalOpen('contact')
      return false
    }else if(!isAgree){
      writeAlertTitle('contact', '개인정보 활용 동의에 체크해 주세요')
      modalOpen('contact')
      return false
    }
    return true;
  }

  const saveContact = async (e) =>{
    e.preventDefault()
    if(isContactValid()){
      writeAlertTitle('contact', '문의가 접수되었습니다')
      try {
        const params = {
          subject : subject,
          email : localPart + '@' + domain,
          content : content,
          status : 'Y'
        }
        const response = await saveContactData(params);
        if (response.data.code === '0000') {
          setLocalPart('')
          setDomain('')
          setSubject('')
          setContent('')
          modalOpen('contact')
        } else {
          writeAlertTitle('contact', '문의접수 실패! 관리자에게 문의해주세요.')
          setAlertTitle()
          modalOpen('contact')
        }
      } catch (error) {
        writeAlertTitle('contact', '문의접수 실패! 관리자에게 문의해주세요.')
        modalOpen('contact')
        console.error(error);
      }
    }
  }

  const makePageList = () => {
    const frontGap = page - 1
    const backGap = totalPage - page
    const isMobile = window.innerWidth < 1200

    if (frontGap <= 2) {
      setPageList([...Array(5).keys()].map(x => page - frontGap + x));
    } else if (backGap <= 2) {
      setPageList([...Array(isMobile ? 2 : 5).keys()].map(x => page - ((isMobile ? 1 : 4) - backGap) + x))
    } else {
      setPageList([...Array(isMobile ? 2 : 5).keys()].map(x => page - (isMobile ? 0 : 2) + x))
    }
  }
  
  // 웨이스트버스뉴스! 가져오는 용
  const getNewsList = async () => {
    try {
      const params = {
        page : page
      }
      const response = await getNewsByPage(params);
      if (response?.data?.code === '0000') {
        const newsList = response.data?.data?.news.map(news => ({
          date: moment(new Date(news.write_date)).format('YYYY-MM-DD'),
          title: Util.replaceHtmlTag(news.subject),
          content: Util.replaceHtmlTag(news.content),
          link: news.link,
          img: news.image_url
        }));
        setNewsList(newsList);
        setTotalPage(response.data?.data?.total_pages)
        if(!page){
          //setPage(response.data?.data?.page || '')
          setPage(1)
          makePageList()
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getNewsList()
  }, [page])

  useEffect(() => {
    if(page && totalPage){
      makePageList()
    }
  }, [page, totalPage])
    
  const text1 = '스마트 음식물 쓰레기 관리의 시작, 웨이스트버스 플랫폼 과 지금 함께하세요!';
  const text2 = '실시간 데이터와 혁신 기술로 음식물류 폐기물 관리의 효율성과 투명성을 높이는 통합 플랫폼입니다.';

  const useWordAnimation = (text, timeout = 0, delay = 100) => {
    const textArray = text.split(' ');
    const [animatedIndices, setAnimatedIndices] = useState([]);

    useEffect(() => {
      let index = 0;
      let intervalId
      const timeoutId = setTimeout(() => {
      const interval = setInterval(() => {
        setAnimatedIndices((prev) => [...prev, index]);
        index++;
        if (index >= textArray.length) {
          clearInterval(interval);
        }
      }, delay);
    }, timeout)

      return () => {
        clearTimeout(timeoutId)
        clearInterval(intervalId)
      };
    }, [text]);

    return { textArray, animatedIndices };
  }

  const { textArray: animationTextArray1, animatedIndices: animatedIndices1 } = useWordAnimation(text1);
  const { textArray: animationTextArray2, animatedIndices: animatedIndices2 } = useWordAnimation(text2);

  return (
    <Fragment>
      <section id="sec_4_1" className="customer-section" style={{ position: "relative", width: '100%', backgroundImage: `url(${mainBanner})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000066', zIndex: 1 }}></div>
        <div className="customer-main-text-container">
          <p>
          {animationTextArray1.map((letter, index) => (
            <Fragment key={letter + index}>
              <span
                className={`${animatedIndices1.includes(index) ? 'text-animated' : 'opacity-0'} customer-main-text-1`}
                style={{ color: ['웨이스트버스', '플랫폼'].includes(letter) ? '#45C2B1' : 'white' }}
              >
                {letter === '플랫폼' ? letter : letter + '\u00A0'}
              </span>
              {index === 4 && <br />}
            </Fragment>
          ))}
          </p>
          <p style={{marginTop: 20}}>
          {animationTextArray2.map((letter, index) => (
            <Fragment key={letter + index}>
              <span
                className={`${animatedIndices2.includes(index) ? 'text-animated' : 'opacity-0'} customer-main-text-2`}
              >
                {letter + '\u00A0'}
              </span>
              {index === 7 && <br />}
            </Fragment>
          ))}
          </p>
        </div>
      </section>
      <div style={{ width: '100%', position: "relative", padding: '120px 0' }}>
        <div id="sec_4_5" className="inner-container" style={{marginBottom: 80}} >
          <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>언론보도</p>
          <p style={{ marginTop: 20, fontWeight: '600', fontSize: 18, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>웨이스트버스 서비스 신규소식 안내드립니다.</p>
          <div className="weaver-news-container" style={{ marginTop: 50, width: '100%', borderTop: '1px solid #7D8895', borderBottom: '1px solid #EAEAEA' }}>
            {weaverNews.map((item, index) => (
              <div key={'customer_section1' + index} style={{ width: '100%', padding: '20px 30px', display: "flex", gap: 30, alignItems: 'center', cursor: "pointer" }} onClick={() => {
                window.open(item.url, '_blank');
              }}>
                <img src={item.img} alt="" style={{ width: 320, height: 200, flexShrink: 0 }} />
                <div>
                  <p style={{ fontSize: 16, lineHeight: '150%', color: '#707E92' }}>{item.date}</p>
                  <p style={{ marginTop: 10, fontWeight: '600', lineHeight: '150%', fontSize: 22, color: '#1F2D3D' }}>{item.title}</p>
                  <p style={{ marginTop: 10, fontSize: 16, lineHeight: '150%', color: '#3C4858', letterSpacing: -1 }}>
                    {item.content.split('\n').map((line, i) => (
                      <Fragment key={line + i}>
                        {line}
                        <br />
                      </Fragment>
                    ))}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="weaver-news-mobile-container" style={{ marginTop: 50, width: '100%', borderTop: '1px solid #7D8895' }}>
            {weaverNews.map((item, index) => (
              <div key={'customer_section_mobile1_' + index} style={{ width: '100%', padding: '20px 0', borderBottom: '1px solid #EAEAEA' }} onClick={() => {
                window.open(item.url, '_blank');
              }}>
                <p style={{ fontSize: 16, lineHeight: '150%', color: '#707E92' }}>{item.date}</p>
                <p style={{ marginTop: 10, fontWeight: '600', lineHeight: '150%', fontSize: 22, color: '#1F2D3D' }}>{item.title}</p>
                <p style={{ marginTop: 10, fontSize: 16, lineHeight: '150%', color: '#3C4858', letterSpacing: -1 }}>
                  {item.content.split('\n').map((line, i) => (
                    <Fragment key={line + i}>
                      {line}
                      <br />
                    </Fragment>
                  ))}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div id="sec_4_2" className="inner-container" >
          <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>업계소식</p>
          <p style={{ marginTop: 20, fontWeight: '600', fontSize: 18, lineHeight: '150%', color: '#1F2D3D', textAlign: 'center' }}>폐기물 업계의 신규소식을 안내드립니다.</p>
          <div className="weaver-news-container" style={{ marginTop: 50, width: '100%', borderTop: '1px solid #7D8895', borderBottom: '1px solid #EAEAEA' }}>
            {newsList.map((item, index) => (
              <div key={'customer_section1' + index} style={{ width: '100%', padding: '20px 30px', display: "flex", gap: 30, alignItems: 'center' }}>                
                <img src={item.img} alt="" style={{ width: 320, height: 200, flexShrink: 0 }} />
                <div>
                  <p style={{ fontSize: 16, lineHeight: '150%', color: '#707E92' }}>{item.date}</p>
                  <p style={{ marginTop: 10, fontWeight: '600', lineHeight: '150%', fontSize: 22, color: '#1F2D3D' }}>{item.title}</p>
                  <p style={{ marginTop: 10, fontSize: 16, lineHeight: '150%', color: '#3C4858', letterSpacing: -1 }}>
                    {item.content.split('\n').map((line, i) => (
                      <Fragment key={line + i}>
                        {line}
                        <br />
                      </Fragment>
                    ))}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="weaver-news-mobile-container" style={{ marginTop: 50, width: '100%', borderTop: '1px solid #7D8895' }}>
            {newsList.map((item, index) => (
              <div key={'customer_section_mobile1_' + index} style={{ width: '100%', padding: '20px 0', borderBottom: '1px solid #EAEAEA' }}>
                <p style={{ fontSize: 16, lineHeight: '150%', color: '#707E92' }}>{item.date}</p>
                <p style={{ marginTop: 10, fontWeight: '600', lineHeight: '150%', fontSize: 22, color: '#1F2D3D' }}>{item.title}</p>
                <p style={{ marginTop: 10, fontSize: 16, lineHeight: '150%', color: '#3C4858', letterSpacing: -1 }}>
                  {item.content.split('\n').map((line, i) => (
                    <Fragment key={line + i}>
                      {line}
                      <br />
                    </Fragment>
                  ))}
                </p>
              </div>
            ))}
          </div>
          <div style={{margin: '20px auto 0', padding: '20px 0 0', display: 'flex', width: 'fit-content', gap: 12, alignItems: "center"}}>
            <button style={{width: 38, height: 34, border: '1px solid #EAEAEA', backgroundColor:'#fff', borderRadius: 8, textAlign: "center", padding: 0}} onClick={() => {
              if(page !== 1){
                setPage(prev => prev - 1)
              }
            }}>
              <img style={{width: 19, height: 19}} src={page === 1 ? leftArrowDisabled : leftArrow} />
            </button>
            {page - 1 > 2 &&
              <button style={{width: 38, height: 34, border: `1px solid ${page === 1 ? '#F4F6FA' : '#EAEAEA'}`, backgroundColor:'#fff', borderRadius: 8, lineHeight: '34px', textAlign: "center", color: page === 1 ? '#5436EA' : '#292E41', padding: 0}} onClick={() => {
                setPage(1)
              }}>1</button>
            }
            <img style={{width: 19, height: 19, display: page - 1 > 2 ? 'block' : 'none'}} src={omission} />
            {pageList.map((item, index) => (
            <button key={'waver_news_page_'+index} style={{width: 38, height: 34, border: `1px solid ${page === item ? '#F4F6FA' : '#EAEAEA'}`, backgroundColor: `${page === item ? '#F4F6FA' : '#FFF'}`, borderRadius: 8, lineHeight: '34px', textAlign: "center", color: page === item ? '#5436EA' : '#292E41', padding: 0}} onClick={() => {setPage(item)}}>{item}</button>
            ))}
            <button style={{width: 38, height: 34, border: '1px solid #EAEAEA', backgroundColor:'#fff', borderRadius: 8, textAlign: "center", padding: 0}} onClick={() => {
              if(page !== totalPage){
                setPage(prev => prev + 1)
              }
            }}>
              <img style={{width: 19, height: 19}} src={page === totalPage ? rightArrowDisabled : rightArrow} />
            </button>
          </div>
        </div>
        <div  id="sec_4_3" className="inner-container" style={{ marginTop: 120 }}>
          <div style={{ width: '100%', textAlign: 'center', color: '#1F2D3D' }}>
            <p style={{ fontWeight: '700', fontSize: 40, lineHeight: '150%' }}>COMPANY PROFILE</p>
            <p style={{ fontWeight: '600', fontSize: 18, lineHeight: '150%', marginTop: 20 }}>회사소개서</p>
          </div>
          <div className="company-intro-container">
            <div style={{textAlign: "center", color: '#C7CDD7'}}>
              <p style={{fontWeight: '600', fontSize: 36, lineHeight: '120%'}}>22</p>
              <p style={{fontWeight: '500', fontSize: 16, lineHeight: '120%'}}>2025-02</p>
            </div>
            <div style={{width: 818, display: "flex", gap: 10}}>
              <div style={{padding: '6px 20px', borderRadius: 100, backgroundColor: '#45C2B1', fontWeight: '600', fontSize: 15, lineHeight: '130%', color: 'white'}}>PDF</div>
              <p style={{fontWeight: '600', fontSize: 20, lineHeight: '150%', color: '#1F2D3D'}}>2025년 웨이스트버스 회사소개</p>
            </div>
            <button style={{padding: '10px 30px', display: "flex", gap: 10, border: '2px solid black', alignItems: "center", borderRadius: 100, backgroundColor: 'white'}} onClick={() => {
              modalOpen('service')
              writeAlertTitle('service', '서비스 준비중입니다.')
            }}>
              <p style={{fontWeight: '600', fontSize: '15', lineHeight: '150%', color: '#3C4858'}}>DOWNLOAD</p>
              <img src={download} />
            </button>
          </div>
          <div className="company-intro-mobile-container">
            <div style={{display: "flex", justifyContent: "space-between", width: '100%', marginTop: 22, alignItems: "center"}}>
              <div style={{textAlign: "center", color: '#C7CDD7'}}>
                <p style={{fontWeight: '600', fontSize: 36, lineHeight: '120%'}}>22</p>
                <p style={{fontWeight: '500', fontSize: 16, lineHeight: '120%'}}>2025-02</p>
              </div>
              <button style={{padding: '10px 30px', display: "flex", gap: 10, border: '2px solid black', alignItems: "center", borderRadius: 100, backgroundColor: 'white'}} onClick={() => {
                modalOpen('service')
                writeAlertTitle('service', '서비스 준비중입니다.')
              }}>
                <p style={{fontWeight: '600', fontSize: '15', lineHeight: '150%', color: '#3C4858'}}>DOWNLOAD</p>
                <img src={download} />
              </button>
            </div>
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16}}>
              <div style={{padding: '6px 20px', borderRadius: 100, backgroundColor: '#45C2B1', fontWeight: '600', fontSize: 15, lineHeight: '130%', color: 'white'}}>PDF</div>
              <p style={{fontWeight: '600', fontSize: 20, lineHeight: '150%', color: '#1F2D3D'}}>2025년 웨이스트버스 회사소개</p>
            </div>
          </div>
          <div id="sec_4_4" style={{width: '100%', textAlign: 'center', color: '#1F2D3D', marginTop: 120}}>
            <p style={{fontWeight: '700', fontSize: 40, lineHeight: '150%'}}>CONTACT</p>
            <p style={{fontWeight: '600', fontSize: 18, lineHeight: '150%', marginTop: 20}}>1:1문의를 남겨주시면 빠르게 답변해드리겠습니다.</p>
          </div>
          <div style={{width: '100%', marginTop: 50}}>
            <div style={{marginTop: 20, width: '100%'}}>
              <div className="inquiry-mobile">
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>문의제목<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <input id="company-name" style={{width: '100%', height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px', marginTop: 6}} value={subject} onChange={(e) => {
                    setSubject(e.target.value)
                  }}/>
                </div>
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>이메일<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <div style={{display: "flex", gap: 10}}>
                    <input id="local-part" style={{width: 144, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={localPart} onChange={(e) => {
                      setLocalPart(e.target.value)
                    }} />
                    <p style={{lineHeight: '44px'}}>@</p>
                    <input id="domain" style={{width: 144, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={domain} onChange={(e) => {
                      setDomain(e.target.value)
                    }} />
                  </div>
                </div>
                <div style={{marginTop: 16}}>
                  <p style={{fontSize: 15}}>문의내용<span style={{color: '#22B5A1'}}>&nbsp;*</span></p>
                  <textarea id="inquiry-content" style={{width: '100%', height: 260, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} placeholder="문의 내용을 입력하세요." value={content} onChange={(e) => {
                    setContent(e.target.value)
                  }} />
                </div>
              </div>
              <table className="inquiry-table">
                <tbody style={{color: '#1F2D3D'}}>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>문의제목<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, paddingLeft: 20}}>
                      <input id="company-name" style={{width: '100%', height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={subject} onChange={(e) => {
                        setSubject(e.target.value)
                      }} />
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>이메일<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, paddingLeft: 20}}>
                      <div style={{display: "flex", gap: 10}}>
                        <input id="local-part" style={{width: 200, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={localPart} onChange={(e) => {
                          setLocalPart(e.target.value)
                        }} />
                        <p style={{lineHeight: '44px'}}>@</p>
                        <input id="domain" style={{width: 200, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} value={domain} onChange={(e) => {
                          setDomain(e.target.value)
                        }} />
                        <select id="domain-select" style={{width: 200, height: 44, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '0 16px'}} value={domain} onChange={(e) => {
                          setDomain(e.target.value)
                        }}>
                          <option value={''}>직접입력</option>
                          <option value={'naver.com'}>naver.com</option>
                          <option value={'gmail.com'}>gmail.com</option>
                          <option value={'kakao.com'}>kakao.com</option>
                          <option value={'nate.com'}>nate.com</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                  <tr style={{height: 66, borderBottom: '1px solid #EAEAEA'}}>
                    <td style={{width: 200, fontWeight: '600', fontSize: 15, lineHeight: '20px', letterSpacing: -0.5, paddingLeft: 20}}>문의내용<span style={{color: '#22B5A1'}}>&nbsp;*</span></td>
                    <td style={{width: 1000, padding: 20}}>
                      <textarea id="inquiry-content" style={{width: 960, height: 260, border: '1px solid #DDDDDD', fontSize: 15, color: '#1F2D3D', borderRadius: 8, padding: '14.5px 16px'}} placeholder="문의 내용을 입력하세요." value={content} onChange={(e) => {
                        setContent(e.target.value)
                      }} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{padding: '20px 0', width: '100%', display: 'flex', justifyContent: "center", marginTop: 20}}>
              <div style={{display: "flex", alignItems: 'center'}}>
                <label htmlFor="agreement" className="custom-checkbox-label">
                  <input id="agreement" type="checkbox" className="custom-checkbox-input" checked={isAgree} onChange={(e) => {setIsAgree(e.target.checked)}} />
                  <span className="custom-checkbox-box"></span>
                  <span htmlFor="agreement" style={{fontSize: 15, lineHeight: '150%', color: '#1F2125', marginLeft: 8}}>상담문의을 위한 개인정보 활용을 동의합니다.</span>
                </label>
                <p style={{fontSize: 15, lineHeight: '20px', color: '#1F2125', textDecoration: 'underline', letterSpacing: -0.5, marginLeft: 20, cursor: "pointer"}}>자세히보기</p>
              </div>
            </div>
            <div style={{padding: '20px 0 0', width: '100%', display: 'flex', justifyContent: "center", marginTop: 20}}>
              <div style={{display: "flex", gap: 10}}>
                <button style={{padding: 16, backgroundColor: '#E8EBEF', borderRadius: 8, border: 'none'}}>
                  <p className="inquiry-button-text" style={{color: '#1F2D3D'}}>취소</p>
                </button>
                <button style={{padding: 16, backgroundColor: '#22B5A1', borderRadius: 8, border: 'none'}} onClick={(e) => {
                  saveContact(e)
                }}>
                  <p className="inquiry-button-text" style={{color: 'white'}}>문의접수</p>
                </button>
              </div>
            </div>
          </div>
          {modalShow.contact &&
            <SweetAlert
              title={<span className='justify-content-center d-flex noMargin text-black font-weight-bold font-size-18' style={{marginBottom: 10, marginTop: 10}}>
                {alertTitle.contact}
              </span>}
              onConfirm={() => {
                modalClose('contact')
              }}
            />
          }
        </div>
      </div>
      <section className="contact-us" style={{ backgroundImage: `url(${bottomBanner})` }}>
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000066', zIndex: 1}}></div>
        <div className="contact-us-container">
          <p style={{textAlign: "center", fontWeight: '700', fontSize: 40, lineHeight: '150%', color: 'white'}}>CONTACT US</p>
          <div className="contact-us-button-container">
            <button className="contact-us-button" onClick={() => {
              // modalOpen('service')
              // writeAlertTitle('service', '서비스 준비중입니다.')
              window.open('https://pf.kakao.com/_xffgin', '_blank');
            }}>
              <img src={storeSvg13} />
              <div style={{color: "white"}}>
                <p style={{fontWeight: '600', fontSize: 26, lineHeight: '140%'}}>카카오채널 1:1 상담</p>
                <p style={{marginTop: 2, fontWeight: '500', fontSize: 15, lineHeight: '140%'}}>(오전 9시부터 오후 6시까지 상담가능)</p>
              </div>
            </button>
            <button className="contact-us-button" onClick={() => {
              // modalOpen('service')
              // writeAlertTitle('service', '서비스 준비중입니다.')
              window.open('http://pf.kakao.com/_xffgin/chat', '_blank');
            }}>
              <img src={storeSvg14} />
              <p style={{color: "white", fontWeight: '600', fontSize: 26, lineHeight: '140%'}}>AI 챗봇 상담</p>
            </button>
          </div>
        </div>
        {modalShow.service &&
          <SweetAlert
            title={<span className='justify-content-center d-flex noMargin text-black font-weight-bold font-size-18' style={{marginBottom: 10, marginTop: 10}}>
              {alertTitle.service}
            </span>}
            onConfirm={() => {
              modalClose('service')
            }}
          />
        }
      </section>
    </Fragment>
  )
};

export default CustomerSupport